<script>
    import { createEventDispatcher } from "svelte";
    import { sanitizeHtml } from "../../sanitize.js";

    export let options = [];
    export let selectedOptionIds = [];
    export let questionIndex = 0;

    const dispatch = createEventDispatcher();

    function isOptionSelected(optionId) {
        return selectedOptionIds?.includes(optionId);
    }

    function handleSelect(optionId) {
        dispatch("select", { optionId });
    }
</script>

<div class="options-list">
    {#each options as option}
        <label
            class="option bg-base-100 hover:border-primary hover:bg-primary/10 {isOptionSelected(option.serverId) ? 'border-primary bg-primary/20' : 'border-primary/30'}"
            class:selected={isOptionSelected(option.serverId)}
        >
            <input
                type="radio"
                name="question-{questionIndex}"
                value={option.serverId}
                checked={isOptionSelected(option.serverId)}
                on:change={() => handleSelect(option.serverId)}
                class="radio radio-content"
            />
            <span class="option-text text-base-content">{@html sanitizeHtml(option.optionText)}</span>
        </label>
    {/each}
</div>

<style>
    .options-list {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    .option {
        display: flex;
        align-items: center;
        gap: 1rem;
        padding: 1rem 1.5rem;
        border: 2px solid;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.2s;
    }

    .option input {
        width: 20px;
        height: 20px;
        cursor: pointer;
    }

    .option-text {
        flex: 1;
        font-size: 1rem;
        line-height: 1.5;
    }
</style>
